import TicketTemplate from './TicketTemplate';

export default TicketTemplate;
